import OurTeamDetail from '../sections/our-team-detail/OurTeamDetail';
import App from '../App';

window.App = App;
window.Section = OurTeamDetail;
